// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { Button } from "../../../revvComponents";

// Components Imports

// Action Imports
import {
  GoogleSheetActions,
  QuotationActions,
  EditorActions,
} from "../../../actions";
import { updateComponentMeta } from "../../../actions/DocumentActions/index";

// Internal Imports
import { COMMON } from "../../../constants";
import { GlobalUtils } from "../../../utils";
// Service Imports && Methods
import {
  authGoogleSheetService,
  fetchGoogleUserInfo,
} from "../../../actions/GoogleSheetActions/googleSheetServices";
import { convertSectionTableToGSheet } from "../utils";

// Action Imports
const { toggleTabAndToolPanelData, handleGSheetAuth } = QuotationActions;
const { nukeActiveEditor } = EditorActions;

// Destructuring
const { checkGSheetStoreForData } = GoogleSheetActions;
const { TABLE_TYPE } = COMMON;
const { writeDataToLocalStorage } = GlobalUtils;
class TableToGsheetConfirmationPopup extends Component {
  state = {};

  componentDidMount() {
    if (!this.props.isGoogleSheetAuthenticated) {
      fetchGoogleUserInfo()
        .then(() => {
          this.props.handleGSheetAuth(true);
        })
        .catch(error => {
          console.error("error", error);
        });
    }
  }

  _closePopup = () => {
    this.props.updateMultipleState({
      showTabletoGsheetConfirmation: false,
    });
  };

  _moveToLinkedGoogleSheet = section => {
    const { content } = section;
    checkGSheetStoreForData(content.id);
    if (this.props.isLocked) {
      this.props.toggleTabAndToolPanelData({
        tabView: content.label,
        isOpen: false,
        panelView: "",
        page: TABLE_TYPE.GOOGLE_SHEET,
        tabViewType: TABLE_TYPE.GOOGLE_SHEET,
        googleSheetId: content.id,
      });
    } else {
      this.props.toggleTabAndToolPanelData({
        tabView: content.label,
        isOpen: true,
        panelView: "google-catalog",
        page: TABLE_TYPE.GOOGLE_SHEET,
        tabViewType: TABLE_TYPE.GOOGLE_SHEET,
        googleSheetId: content.id,
      });
    }
  };

  _authGoogleSheet = section => {
    // this refers ==> when google sheet auth success then move to particular tab
    const { content } = section;
    const clickedTabItem = {
      name: content.label,
      alias: content.label,
      type: content.type,
      id: content.id,
    };
    authGoogleSheetService()
      .then(res => {
        writeDataToLocalStorage("lastDocPath", window.location.pathname);
        writeDataToLocalStorage("clickedTabItem", clickedTabItem);
        window.location.replace(res.AuthCodeURL);
      })
      .catch(error => {
        console.error(`SignUp => authEmailVerificationService => ${error}`);
      });
  };

  _checkUserIsAuthenticatedOrNot = section => {
    if (this.props.isGoogleSheetAuthenticated) {
      this._moveToLinkedGoogleSheet(section);
    } else {
      this._authGoogleSheet(section);
    }
  };

  _handleConfirmation = () => {
    this.props.updateComponentMeta({});
    this.props.nukeActiveEditor();
    const updatedTableData = convertSectionTableToGSheet(
      this.props.currentSection,
    );
    this.props.saveTable(updatedTableData);
    const updatedSection = {
      ...this.props.currentSection,
      content: {
        ...this.props.currentSection.content,
        data: updatedTableData,
        label: updatedTableData.attributes.label,
      },
    };
    this._checkUserIsAuthenticatedOrNot(updatedSection);
  };

  render() {
    return (
      <Modal open onClose={this._closePopup} closeOnOverlayClick={false} center>
        <div
          className="modal-container table-gsheet-popup-container"
          data-test="table-gsheet-popup-container">
          <div
            className="modal-heading table-to-gsheet-heading"
            data-test="table-gsheet-popup-modal-heading">
            <span role="img" aria-label="">
              ⚠️
            </span>{" "}
            <span>Importing data will replace existing data</span>
          </div>
          <div className="modal-form">
            <div
              className="modal-form-field"
              data-test="table-gsheet-popup-form">
              You&apos;re about to link this table to a Google sheet. Any
              existing data will be replaced by imported data.
            </div>
          </div>

          <div className="modal-footer">
            <Button
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="table-gsheet-popup-cancle-btn"
              onClick={this._closePopup}>
              Go back
            </Button>
            <Button
              className="btn btn-primary modal-footer-btn submit-btn"
              data-test="table-gsheet-popup-submit-btn"
              onClick={() => this._handleConfirmation()}>
              Continue
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { isGoogleSheetAuthenticated, activeComponentMeta, components } =
    state.DocumentStore;

  return {
    currentSection: components[activeComponentMeta.componentId],
    isGoogleSheetAuthenticated,
  };
};

const mapDispatchToProps = {
  toggleTabAndToolPanelData,
  handleGSheetAuth,
  updateComponentMeta,
  nukeActiveEditor,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableToGsheetConfirmationPopup);
